import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Alert, Box, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { canViewPricingReports } from "../../common/utils/pricingReportsAccess";
import { beefAiConfigured } from "../../services/beefAiPricing";
import VerifyPricePanelContent from "./VerifyPricePanelContent";
import { useVerifyPricePanelState } from "./useVerifyPricePanelState";

export function VerifyPricePanel() {
  const user = useSelector((state) => state.user);
  const userMayViewPricingReports = canViewPricingReports(user);
  const beefAiClientConfigured = beefAiConfigured();

  const panelState = useVerifyPricePanelState({
    queriesEnabled: userMayViewPricingReports && beefAiClientConfigured,
  });

  if (!userMayViewPricingReports) {
    return (
      <Box sx={{ py: 1 }}>
        <Alert severity="warning">
          You do not have access to Verify Price. If you believe this is a mistake, contact your Canada Beef
          administrator.
        </Alert>
        <Button component={Link} to="/dashboard" sx={{ mt: 2 }} variant="contained">
          Back to dashboard
        </Button>
      </Box>
    );
  }

  if (!beefAiClientConfigured) {
    return (
      <Box sx={{ py: 1 }}>
        <Alert severity="warning">
          Verify Price is not configured. Set `REACT_APP_PRICE_DIRECTUS_URL` and `REACT_APP_PRICE_DIRECTUS_TOKEN` for
          this environment, then reload the page.
        </Alert>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <VerifyPricePanelContent panelState={panelState} />
    </LocalizationProvider>
  );
}

export default VerifyPricePanel;
